<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { mapActions } from "vuex";
import { getQueryParam } from '@/utils/common.js';

export default {
  name: "App",
  data() {
    return {
      locale: zhCN,
      tokens: ""
    };
  },
  methods: {
    ...mapActions(["collectRequestLog"]),
    initClientHeight() {
      // vue、H5解决安卓手机软键盘弹出,页面高度被顶起 导致视频随页面高度变化的问题
      const originalHeight = document.documentElement.clientHeight || document.body.clientHeight
      //键盘弹起与隐藏都会引起窗口的高度发生变化
      const resizeHeight = document.documentElement.clientHeight || document.body.clientHeight // 软键盘弹起时的页面高度
      const keyboardHeight = originalHeight - resizeHeight // 软键盘弹起的高度
      // console.log('进入到判断页面高度=========')
      // console.log('页面初始高度=========' + originalHeight)
      // console.log('软键盘弹起时的页面高度=========' + resizeHeight)
      // console.log('软键盘弹起的高度=========' + keyboardHeight)
      const chatRoomContainer = document.querySelector('.chat-room-container')
      if (resizeHeight < originalHeight) {
        //当软键盘弹起，在此处操作
        // console.log('进入到软键盘弹起=========')
        document.querySelector('body').setAttribute('style', 'height:' + originalHeight + 'px;')
        if (chatRoomContainer) {
          chatRoomContainer.setAttribute('style', 'bottom:' + keyboardHeight + 'px;')
        }
        this.scrollerHeight = resizeHeight
      } else {
        //当软键盘收起，在此处操作
        // console.log('进入到软键盘收起=========')
        document.querySelector('body').setAttribute('style', 'height:100%;')
        if (chatRoomContainer) {
          chatRoomContainer.setAttribute('style', 'bottom:' + '0')
        }
        this.scrollerHeight = '100%'
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.initClientHeight)
    if(!getQueryParam('visitorFirstGlobalUnique')) {
      this.collectRequestLog({ step: "first", result: "success,chat" });
    }
  }
};
</script>
<style lang="less"></style>



// WEBPACK FOOTER //
// src/App.vue